/* eslint-disable react/no-array-index-key */
import styled from '@emotion/styled';
import { Spacings } from '@styles/index';
import Answering from './Sections/Answering';
import General from './Sections/General';
import QuestionNavigation from './Sections/QuestionNavigation';
import SectionNavigation from './Sections/SectionNavigation';

const Wrapper = styled.div`
  grid-column: span 10;
  margin-bottom: ${Spacings.SPACING_6B};
`;

const InstructionsInfo = ({ name = '', time = 0, showSectionInfo = false }) => {
  const timeInMinutes = time / 60;

  return (
    <Wrapper>
      <General name={name} timeInMinutes={timeInMinutes} />
      <QuestionNavigation />
      <Answering />
      {showSectionInfo && <SectionNavigation />}
    </Wrapper>
  );
};

export default InstructionsInfo;
